import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { Navigate } from 'react-router-dom'
import { JarvisOrb } from '@/components/JarvisOrb'
import { HAS_AUTH, loginRequest } from '@/lib/auth'
import { usePersona } from '@/lib/personas'

export function LoginPage() {
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const { persona } = usePersona()

  if (isAuthenticated) return <Navigate to="/dashboard" replace />

  const handleLogin = () => {
    if (!HAS_AUTH) {
      // Mock mode — go straight to dashboard
      window.location.href = '/dashboard'
      return
    }
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error('[auth] loginRedirect failed', e)
    })
  }

  return (
    <div className="min-h-screen bg-jarvis-dark flex flex-col items-center justify-center gap-10 p-6">
      <JarvisOrb state="idle" size="lg" />
      <div className="text-center">
        <h1 className="text-5xl font-bold text-jarvis-text tracking-tight">
          {persona.wordmark}
        </h1>
        <p className="text-jarvis-muted mt-3 text-sm uppercase tracking-widest">
          {persona.tagline}
        </p>
      </div>
      <button
        onClick={handleLogin}
        className="px-10 py-3 bg-jarvis-blue text-white rounded-lg font-medium tracking-wide
                   hover:bg-jarvis-blue-bright transition-colors shadow-lg shadow-jarvis-blue/20"
      >
        Sign In
      </button>
      <p className="text-xs text-jarvis-muted">
        Activates immediately · Cancel any time
      </p>
    </div>
  )
}
